export const createLocalStorage = (key: string) => {
  return {
    get: () => localStorage.getItem(key),
    set: (value: string) => localStorage.setItem(key, value),
    remove: () => localStorage.removeItem(key),
  };
};
